import { randomCssVar } from '../../helpers/styles.esm.js';

var TOOLTIP_BACKGROUND_COLOR_VAR = randomCssVar();
var TOOLTIP_COLOR_VAR = randomCssVar();
var TOOLTIP_BORDER_RADIUS_VAR = randomCssVar();

export { TOOLTIP_BACKGROUND_COLOR_VAR, TOOLTIP_BORDER_RADIUS_VAR, TOOLTIP_COLOR_VAR };
